import React from "react";

export const ViewMoreButton = () => {
  return (
    <div className="vm-btn">
      <button>VER MÁS</button>
    </div>
  );
};
